importÂ {Â InjectableÂ }Â fromÂ '@angular/core';

importÂ {Â AppStateÂ }Â fromÂ './app.reducer';

importÂ {Â combineLatest, Observable }Â fromÂ 'rxjs';

importÂ {Â StoreÂ }Â fromÂ '@ngrx/store';
import { map } from 'rxjs/operators';

@Injectable()
export class StoreSelectors {


    constructor(public store: Store<AppState>) {
    }

    getAll(selectAll): Observable<any> {
        return this.store.select(selectAll);
    }

    getIsLoading(isLoading): Observable<any> {
        return this.store.select(isLoading);
    }

    getError(error): Observable<any> {
        return this.store.select(error);
    }

    findById(selectAll, record: { id }) {
        return this.getAll(selectAll)[record['id']];
    }

    getCurrentSelected(selectAll, selectCurrentId) {
        const compained = combineLatest(this.getAll(selectAll),
                        this.store.select(selectCurrentId));

        return compained.pipe(
                        map(() => (entities, selectedId)Â =>Â selectedId.map(idÂ =>Â entities[id])
                    )
                );
    }
}



